import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../../slice'
import createPayRunsSlice, { PayRunsSlice } from './pay-runs/slice'
import createEditPayRunSlice, { EditPayRunSlice } from './pay-runs/edit/slice'

const usePayrollStore = create<PayRunsSlice & EditPayRunSlice & SharedSlice>()(
  (...props) => ({
    ...createSharedSlice(...props),
    ...createPayRunsSlice(...props),
    ...createEditPayRunSlice(...props),
  })
)

export default usePayrollStore
